const DEFAULT_FALSE = false
const DEFAULT_TRUE = true
const DEFAULT_ARRAY = []

const FIELD_PROPERTY_DISABLED = 'disabled'
const FIELD_PROPERTY_REQUIRED = 'required'
const FIELD_PROPERTY_VISIBLE = 'visible'
const FIELD_PROPERTY_FEATURED = 'featured'
const FIELD_PROPERTY_READONLY = 'readonly'
const FIELD_SETTINGS = 'settings'
const FIELD_SETTINGS_VALUES = 'values'
export {DEFAULT_FALSE, DEFAULT_TRUE, DEFAULT_ARRAY, FIELD_PROPERTY_DISABLED,FIELD_PROPERTY_FEATURED, FIELD_PROPERTY_REQUIRED, FIELD_PROPERTY_VISIBLE, FIELD_PROPERTY_READONLY, FIELD_SETTINGS, FIELD_SETTINGS_VALUES}
